import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {User} from 'projects/core/src/lib/login/data/user';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';

@JsonObject('model.time_card.PayPeriod')
export class PayPeriod extends AbstractModel {

  @JsonProperty(String, 'start')
  start?: string;

  @JsonProperty(String, 'finish')
  finish?: string;

  @JsonProperty(String, 'finishClosed')
  finishClosed?: string;

  @JsonProperty(User, 'user')
  user?: User;

  @JsonProperty(ShortProject, 'currentJob')
  currentJob?: ShortProject;

  @JsonProperty(Number, 'workDuration')
  workDuration?: number;

  @JsonProperty(Number, 'paidBreaksDuration')
  paidBreaksDuration?: number;

  @JsonProperty(Number, 'totalTimeDuration')
  totalTimeDuration?: number;

  @JsonProperty(Number, 'unpaidBreaksDuration')
  unpaidBreaksDuration?: number;

  @JsonProperty(Number, 'overtimeWorkDuration')
  overtimeWorkDuration?: number;

  @JsonProperty(Number, 'sickHoursDuration')
  sickHoursDuration?: number;

  @JsonProperty(Number, 'vacationHoursDuration')
  vacationHoursDuration?: number;

  @JsonProperty(Number, 'payableDuration')
  payableDuration?: number;

  @JsonProperty(Number, 'regularWorkDuration')
  regularWorkDuration?: number;

  @JsonProperty(Number, 'clockInsOutsideShop')
  clockInsOutsideShop?: number;

  @JsonProperty(Number, 'clockOutsOutsideShop')
  clockOutsOutsideShop?: number;

  @JsonProperty(Boolean, 'approved')
  approved?: boolean;

  @JsonProperty(Number, 'unresolvedCards')
  unresolvedCards?: number;

  @JsonProperty(Number, 'resolvedCards')
  resolvedCards?: number;

}
